import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages: {
	readonly heroName: {
		readonly id: 'twg-microsite.heroIcons.heroName';
		readonly defaultMessage: 'Teamwork Graph';
		readonly description: 'Accessible heading text for the logged-out hero wordmark.';
	};
	readonly subtitle: {
		readonly id: 'twg-microsite.heroIcons.subtitle';
		readonly defaultMessage: 'Meet the graph that automatically builds your teamwork context from everywhere you work';
		readonly description: 'Hero supporting copy beneath the wordmark on the logged-out home page.';
	};
	readonly previewCta: {
		readonly id: 'twg-microsite.heroIcons.previewCta';
		readonly defaultMessage: 'See your graph preview';
		readonly description: 'Call-to-action label inviting the user to preview their teamwork graph.';
	};
	readonly statusDone: {
		readonly id: 'twg-microsite.heroIcons.statusDone';
		readonly defaultMessage: 'Done';
		readonly description: 'Decorative status lozenge label in the logged-out hero.';
	};
	readonly statusOnTrack: {
		readonly id: 'twg-microsite.heroIcons.statusOnTrack';
		readonly defaultMessage: 'On track';
		readonly description: 'Decorative status lozenge label in the logged-out hero.';
	};
	readonly statusToDo: {
		readonly id: 'twg-microsite.heroIcons.statusToDo';
		readonly defaultMessage: 'To do';
		readonly description: 'Decorative status lozenge label in the logged-out hero.';
	};
	readonly statusAtRisk: {
		readonly id: 'twg-microsite.heroIcons.statusAtRisk';
		readonly defaultMessage: 'At risk';
		readonly description: 'Decorative status lozenge label in the logged-out hero.';
	};
} = defineMessages({
	heroName: {
		id: 'twg-microsite.heroIcons.heroName',
		defaultMessage: 'Teamwork Graph',
		description: 'Accessible heading text for the logged-out hero wordmark.',
	},
	subtitle: {
		id: 'twg-microsite.heroIcons.subtitle',
		defaultMessage:
			'Meet the graph that automatically builds your teamwork context from everywhere you work',
		description: 'Hero supporting copy beneath the wordmark on the logged-out home page.',
	},
	previewCta: {
		id: 'twg-microsite.heroIcons.previewCta',
		defaultMessage: 'See your graph preview',
		description: 'Call-to-action label inviting the user to preview their teamwork graph.',
	},
	statusDone: {
		id: 'twg-microsite.heroIcons.statusDone',
		defaultMessage: 'Done',
		description: 'Decorative status lozenge label in the logged-out hero.',
	},
	statusOnTrack: {
		id: 'twg-microsite.heroIcons.statusOnTrack',
		defaultMessage: 'On track',
		description: 'Decorative status lozenge label in the logged-out hero.',
	},
	statusToDo: {
		id: 'twg-microsite.heroIcons.statusToDo',
		defaultMessage: 'To do',
		description: 'Decorative status lozenge label in the logged-out hero.',
	},
	statusAtRisk: {
		id: 'twg-microsite.heroIcons.statusAtRisk',
		defaultMessage: 'At risk',
		description: 'Decorative status lozenge label in the logged-out hero.',
	},
} as const) satisfies Record<string, MessageDescriptor>;
